var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "19px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 22 Copy 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboards",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Site---Under-Construction-Page_03",
    transform: "translate(-455.000000, -140.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-3",
    transform: "translate(430.000000, 114.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy-2",
    transform: "translate(25.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.738327,16.1862604 L12.6728235,0.937919351 C11.9293467,-0.312639784 10.0706355,-0.312639784 9.3271587,0.937919351 L0.26166789,16.1862604 C-0.481808953,17.4368072 0.447540271,19 1.93449396,19 L20.0654883,19 C21.5524546,19 22.4818165,17.4368072 21.738327,16.1862604",
    id: "Fill-1",
    fill: "#B90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5256546,14.8092024 L10.4571515,14.8260696 C10.3227645,14.8281872 10.2142787,14.9587293 10.2161044,15.1161603 L10.2267032,16.0379204 C10.2285161,16.1953515 10.3399432,16.3224093 10.4743302,16.3203039 L11.5428333,16.3034368 C11.6772329,16.3013068 11.785706,16.1707894 11.7838931,16.0133461 L11.7732816,15.091586 C11.7714813,14.9341549 11.6600542,14.8070848 11.5256546,14.8092024",
    id: "Fill-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1698752,4.72572082 C9.83184133,4.72572082 9.56943177,5.07110384 9.60865755,5.46440441 L10.4387759,13.7881439 C10.5165809,14.5682444 11.4834064,14.5682444 11.5612113,13.7881439 L12.3913297,5.46440441 C12.4305555,5.07110384 12.1681586,4.72572082 11.8301247,4.72572082 L10.1698752,4.72572082 Z",
    id: "Fill-5",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.9398383e0e40e77c430c134263b6579e.svg";
export { ForwardRef as ReactComponent };